module.exports = __webpack_public_path__ + "a770b6797b68e3f8920e473eb824bac0.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/img/loader-big.gif
 ** module id = 659
 ** module chunks = 0
 **/